import { createAction } from '@reduxjs/toolkit';

import { prefix } from '../consts';
import { locations } from '../types';

export const PROMO_GET = `${prefix}/get`;
export const PROMO_SAVE = `${prefix}/save`;
export const PROMO_ADD_RULE = `${prefix}/add_rule`;
export const PROMO_REMOVE_RULE = `${prefix}/remove_rule`;

export interface IGetPromoPayload {
  id: string;
  location: locations;
  leadId?: number;
}

export interface ISavePromo {
  id: string;
}

export interface IRemovePromoRule {
  index: number;
}

export const promoActions = {
  getData: createAction<IGetPromoPayload>(PROMO_GET),
  save: createAction<ISavePromo>(PROMO_SAVE),
  addRule: createAction(PROMO_ADD_RULE),
  removeRule: createAction<IRemovePromoRule>(PROMO_REMOVE_RULE),
};
